// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__C-nop","header":"PatientQuestionnaire_header__14LDQ","info":"PatientQuestionnaire_info__GzFYs"};